export default __webpack_public_path__ + "static/media/select_down_arrow.c4e110c0.svg";